import Vue from 'vue'
import vm from '@/main' ///导入VUE实例
import store from 'store/index' ///导入公共仓库

import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'

// 节流，防抖
let _lastTime = null ////记录上一次点击的时间，这个变量暂时不知道什么时间会被销毁
const throttle = (fn, gapTime) => {
  if (gapTime == null || gapTime == undefined) {
    gapTime = 1500
  }
  // 返回新的函数
  return (function () {
    let context = vm ////这里需要拿到上下文  this很重要
    console.log(_lastTime)
    let _nowTime = +new Date() ////获取当前时间戳
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn.apply(context, arguments) //将this和参数传给原函数
      _lastTime = _nowTime
    }
  })()
}

// 1定义全局点击函数挂在原型链上2在组件中mounted挂载监听全局的点击事件this.globalClick(this.moreSetupMenuRemove);
//3在method中使用 moreSetupMenuRemove
// Vue.prototype.globalClick = function (callback) {

//     document.getElementById('app').onclick = function () {
//         callback();
//     };

//   };

//计算一个Flex盒子内，一行显示的元素  以外还剩几个元素。flexWidth 盒子的宽度 eleWidth 元素的宽度 eleTotalCount 要在盒子里显示的总个数
//返回的count 是 一行显示的元素  以外还剩几个元素
const computerNotShowEleCount = (flexWidth, eleWidth, eleTotalCount) => {
  // console.log(flexWidth)

  // console.log(eleWidth)
  // console.log(eleTotalCount)
  let count = 0
  count = eleTotalCount - parseInt(flexWidth / eleWidth) ///计算取整，得到剩余未显示的实际个数，这里需要注意元素的宽度是加上margin后。
  console.log(count)
  return count
}

//计算当前显示的页面是哪个（控制页面）
const judgeActivePage = () => {
  return store.state.publicinfo.title
  // if (store.state.publicinfo.title == '常用') return '常用'
  // else if (store.state.publicinfo.title == '区域') return '区域'
  // else if (store.state.publicinfo.title == '消息') return '消息'
  // else return '未定义'
}

// 控制CSS的淡出动画，按钮点击时调用objectData 传入的对象名子对象必须有 click 和 fade
/////淡出时间  outTime 决定了动画在什么时间提前结束。
///最终淡入时间由 CSS决定 淡出时间在CSS的总时长的基础上减去outTime的时间
///type  1代表可以直接判断当前组件是否被激活并进行翻转 默认值是0 只进行淡出的操作
const publicFadeInOut = (objectData, outTime, type = 0) => {
  console.log("11111111111111")
  if (objectData.click === true) {
    ////淡出时间  outTime 决定了动画在什么时间结束
    objectData.fade = false
    setTimeout(() => {
      objectData.click = false
    }, outTime)
  } else if (objectData.click === false && type === 1) {
    objectData.fade = true
    objectData.click = true
    console.log(objectData)
  }
}
////对象数据的深度克隆算法 target 要克隆的目标对象    被克隆的原对象 origin
// 保证 target 对象的原有字符属性不会被抹掉. 
//遍历 origin 中的每个属性. 对于 target中没有的属性会创建添加. 对于target 中已有的属性会改变其值
const objectClone = (target, origin) => {
  for (var prep in origin) {
    if (
      Object.prototype.toString.call(origin[prep]) == '[object Array]' ||
      Object.prototype.toString.call(origin[prep]) == '[object Object]'
    ) {
      if (Object.prototype.toString.call(origin[prep]) == '[object Array]') {
        target[prep] = []
      } else {
        target[prep] = {}
      }

      objectClone(target[prep], origin[prep])
    } else {
      console.log(
        Object.prototype.toString.call(origin[prep]) + ':' + origin[prep]
      )
      target[prep] = origin[prep]
    }
  }
}

// const stringClearStar0 = (oneString )=>{
//     console.log( typeof(oneString) )
//     let arr=oneString.split("")   //字符串转数组
//     for(let i = 0 ; i< arr.length ; i++){
//         if( arr[i] === '0' ){
//             arr.shift();
//         }
//         else{
//             return  arr.join("") ///数组转字符串
//         }
//     }
// }

////计算场景规则 不同设备对应显示的文字  传入要计算的字段 1 2 3 4  传入当前字段的值
// 如下
//   openState: 0,   1
//   openStateValue: 0,   2
//   openStateValue1: 0,   3
//   openStateValue2: 0,    4

const showStateText = (state, value, productCode, userOneRule) => {
  if (publicDeviceTypeJudge(productCode, '014', '02', '049')) { //代号 20231207-1
    ////调光类型
    if (state === 1) {
      ///第一个字段的处理
      if (value === 0) {
        return '关闭'
      } else {
        return '打开'
      }
    } else if (state === 2) {
      ///第二个字段的处理
      return value + '%'
    } else if (state === 3) {
      ///第二个字段的处理
      return ''
    } else if (state === 4) {
      ///第二个字段的处理
      return ''
    }
  } else if (
    publicDeviceTypeJudge(
      productCode,
      '01',
      '05',
      '07',
      '021',
      '020',
      '027',
      '028',
      '022',
      "048"  //代号 20231207-1
    )
  ) {
    ////开关类型和通断类型设备
    if (state === 1) {
      ///第一个字段的处理
      if (value === 0) {
        return '关闭'
      } else {
        return '打开'
      }
    } else if (state === 2) {
      ///第二个字段的处理
      return ''
    } else if (state === 3) {
      ///第二个字段的处理
      return ''
    } else if (state === 4) {
      ///第二个字段的处理
      return ''
    }
  } else if (publicDeviceTypeJudge(productCode, '06', '010')) {
    ////A电机类型  010是丙申开合帘电机   细节处理
    if (state === 1) {
      ///第一个字段的处理
      if (value === 1) {
        return '开/升'
      } else if (value === 2) {
        return '关/降'
      } else if (value === 3) {
        return '停止'
      } else if (value === 4) {
        if (userOneRule.openStateValue === 0) {
          return '关/降'
        } else {
          return '开/升'
        }
      } else {
        return ''
      }
    } else if (state === 2) {
      ///第二个字段的处理
      if (userOneRule.openState === 3) {
        return ''
      }
      return value + '%'
    } else if (state === 3) {
      ///第二个字段的处理
      return ''
    } else if (state === 4) {
      ///第二个字段的处理
      return ''
    }
  } else if (publicDeviceTypeJudge(productCode, '08', '016')) {
    ////A空调  ////016是三合一八键环境面板
    if (state === 1) {
      ///第一个字段的处理
      if (value === 1) {
        ///1开 或0关
        return '打开'
      } else {
        return '关闭'
      }
    } else if (state === 2) {
      ///第二个字段的处理 //1,制冷 2，除湿 3，通风 4，制热 5，自动
      if (userOneRule.openState === 0) return '' ////空调是关闭状态时，不显示字段

      if (value === 1) {
        return '制冷'
      } else if (value === 2) {
        return '除湿'
      } else if (value === 3) {
        return '通风'
      } else if (value === 4) {
        return '制热'
      } else if (value === 5) {
        return '自动'
      } else {
        return ''
      }
    } else if (state === 3) {
      ///第二个字段的处理 ///温度设置 范围16-30
      if (userOneRule.openState === 0) return '' ////空调是关闭状态时，不显示字段
      return value + '°'
    } else if (state === 4) {
      ///第二个字段的处理 ///1 自动 2低速 4中速 6高速
      if (userOneRule.openState === 0) return '' ////空调是关闭状态时，不显示字段

      if (value === 1) {
        return '自动'
      } else if (value === 2) {
        return '低速'
      } else if (value === 4) {
        return '中速'
      } else if (value === 6) {
        return '高速'
      } else {
        return ''
      }
    }
  } else if (publicDeviceTypeJudge(productCode, '013')) {
    ////安防控制
    if (state === 1) {
      ///第一个字段的处理
      if (value === 1) {
        ///1布防 或0撤防
        return '布防'
      } else {
        return '撤防'
      }
    } else if (state === 2) {
      ///第二个字段的处理
      return ''
    } else if (state === 3) {
      ///第二个字段的处理
      return ''
    } else if (state === 4) {
      ///第二个字段的处理
      return ''
    }
  } else if (publicDeviceTypeJudge(productCode, '015')) {
    ////A0电机类型
    if (state === 1) {
      ///第一个字段的处理
      if (value === 1) {
        return '开/升'
      } else if (value === 2) {
        return '关/降'
      } else if (value === 3) {
        return '停止'
      } else {
        return ''
      }
    } else if (state === 2) {
      ///第二个字段的处理
      return ''
    } else if (state === 3) {
      ///第二个字段的处理
      return ''
    } else if (state === 4) {
      ///第二个字段的处理
      return ''
    }
  } else if (publicDeviceTypeJudge(productCode, '017')) {
    ////A地暖
    if (state === 1) {
      ///第一个字段的处理
      if (value === 1) {
        ///1开 或0关
        return '打开'
      } else {
        return '关闭'
      }
    } else if (state === 2) {
      ///第二个字段的处理 //无用

      return ''
    } else if (state === 3) {
      ///第二个字段的处理 ///温度设置 范围16-30
      if (userOneRule.openState === 0) return '' ////地暖是关闭状态时，不显示字段
      return value + '°'
    } else if (state === 4) {
      ///第二个字段的处理//无用

      return ''
    }
  } else if (publicDeviceTypeJudge(productCode, '018')) {
    ////A新风控制
    if (state === 1) {
      ///第一个字段的处理
      if (value === 1) {
        ///1开 或0关
        return '打开'
      } else {
        return '关闭'
      }
    } else if (state === 2) {
      ///第二个字段的处理 ////1,内循环 2，外循环
      if (userOneRule.openState === 0) return '' ////新风是关闭状态时，不显示字段
      if (value === 1) {
        return '内循环'
      } else if (value === 2) {
        return '外循环'
      } else {
        return ''
      }
    } else if (state === 3) {
      ///第三个字段的处理
      return ''
    } else if (state === 4) {
      ///第四个字段的处理 ///1 自动 2低速 4中速 6高速
      if (userOneRule.openState === 0) return '' ////新风是关闭状态时，不显示字段
      if (value === 1) {
        return '自动'
      } else if (value === 2) {
        return '低速'
      } else if (value === 4) {
        return '中速'
      } else if (value === 6) {
        return '高速'
      } else {
        return ''
      }
    }
  } else if (publicDeviceTypeJudge(productCode, '023')) {
    ////F路影视控制
    /*1：电源开 2：电源关 3：静音 4，音量加 5：音量减 6:绝对音量 7：上 8：下 9：左 10：右
    11：确定 12：主页 13：菜单 14：返回  21：自定义1  22：自2  23:自3  24：自4  25：自5  26：自6  27：自7  28：自8 29:自9*/
    if (state === 1) {
      ///第一个字段的处理
      switch (value) {
        case 1:
          return '开机'
        case 2:
          return '关机'
        case 3:
          return '静音'
        case 4:
          return '音量加'
        case 5:
          return '音量减'
        case 6:
          return ''
        case 7:
          return '上'
        case 8:
          return '下'
        case 9:
          return '左'
        case 10:
          return '右'
        case 11:
          return '确定'
        case 12:
          return '主页'
        case 13:
          return '菜单'
        case 14:
          return '返回'
        // 以下是用户自定义的文字回显  //代号20211025-1
        case 21:
          // return store.state.configinfo.config023ShowDataText
          return '自定义1'
        case 22:
          // return store.state.configinfo.config023ShowDataText
          return '自定义2'
        case 23:
          // return store.state.configinfo.config023ShowDataText
          return '自定义3'
        case 24:
          // return store.state.configinfo.config023ShowDataText
          return '自定义4'
        case 25:
          // return store.state.configinfo.config023ShowDataText
          return '自定义5'
        case 26:
          // return store.state.configinfo.config023ShowDataText
          return '自定义6'
        case 27:
          // return store.state.configinfo.config023ShowDataText
          return '自定义7'
        case 28:
          // return store.state.configinfo.config023ShowDataText
          return '自定义8'
        case 29:
          // return store.state.configinfo.config023ShowDataText
          return '自定义9'
        default:
          return ''
      }
    } else if (state === 2) {
      ///第二个字段的处理 ////

      return ''
    } else if (state === 3) {
      ///第三个字段的处理
      return ''
    } else if (state === 4) {
      ///第四个字段的处理
      return ''
    }
  } else if (publicDeviceTypeJudge(productCode, '024')) {
    ////A音乐
    ///音乐的绝对音量服务端会返回状态值，其他均无状态反馈。需要注意音量加和音量减是针对绝对音量值进行加减的（不需要在用4和5这个命令），需要进行逻辑判断
    //还需要注意 播放和暂停是两个命令共用的是一个按钮，但是服务端没有状态反馈。所以需要进行本地缓存逻辑进行翻转（默认第一次进来刷新界面是暂停按钮显示）
    /*1：开机 2：关机 3：静音 4，音量加 5：音量减 6：绝对音量7：上一曲8：下一曲9：顺序播放
    10：单曲循环 11：随机播放12：列表循环 13：播放 14：暂停 15：内置音乐16：AUX音乐17:SD音乐18：蓝牙
    19：网络电台 20：在线音乐*/
    if (state === 1) {
      ///第一个字段的处理
      switch (value) {
        case 1:
          return '开机'
        case 2:
          return '关机'
        case 3:
          return '静音'
        case 4:
          return ''
        case 5:
          return ''
        case 6:
          return ''
        case 7:
          return '上一曲'
        case 8:
          return '下一曲'
        case 9:
          return '顺序播放'
        case 10:
          return '单曲循环'
        case 11:
          return '随机播放'
        case 12:
          return '列表循环'
        case 13:
          return '播放'
        case 14:
          return '暂停'
        case 15:
          return '内置音乐'
        case 16:
          return 'AUX音乐'
        case 17:
          return 'SD音乐'
        case 18:
          return '蓝牙'
        case 19:
          return '网络电台'
        case 20:
          return '在线音乐'
        default:
          return ''
      }
    } else if (state === 2) {
      ///第二个字段的处理 ////
      if (userOneRule.openState === 6) {
        ///说明当前是绝对音量
        return '音量:' + value
      }
      return ''
    } else if (state === 3) {
      ///第三个字段的处理
      return ''
    } else if (state === 4) {
      ///第四个字段的处理
      return ''
    }
  } else if (publicDeviceTypeJudge(productCode, '025')) {
    ////F双色控制
    if (state === 1) {
      ///第一个字段的处理 ///白光 0-100

      return '白光:' + value + '%'
    } else if (state === 2) {
      ///第二个字段的处理 //暖光 0-100
      return '暖光:' + value + '%'
    } else if (state === 3) {
      ///第二个字段的处理
      return ''
    } else if (state === 4) {
      ///第二个字段的处理
      return ''
    }
  } else if (publicDeviceTypeJudge(productCode, '026')) {
    ////F三色控制
    if (state === 1) {
      ///第一个字段的处理 /////红光 0-100

      return '红光:' + value + '%'
    } else if (state === 2) {
      ///第二个字段的处理 ////绿光 0-100
      return '绿光:' + value + '%'
    } else if (state === 3) {
      ///第三个字段的处理 ///蓝光 0-100
      return '蓝光:' + value + '%'
    } else if (state === 4) {
      ///第四个字段的处理 ///呼吸模式 0停止呼吸 1红色呼吸 2绿色呼吸 3蓝色呼吸 4三色呼吸
      switch (value) {
        case 0:
          return '停止呼吸'
        case 1:
          return '红色呼吸'
        case 2:
          return '绿色呼吸'
        case 3:
          return '蓝色呼吸'
        case 4:
          return '三色呼吸'
        default:
          return ''
      }
    }
  }
}

/////计算不同设备类型的规则开关按钮按下后的处理方案
const smartSceneRuleImgChange = (userOneRule, oneRule) => {
  if (
    publicDeviceTypeJudge(
      userOneRule.productCode,
      '01',
      '021',
      '020',
      '05',
      '027',
      '028',
      '022',
      "048"  //代号 20231207-1
    )
  ) {
    ////这几种设备不需要二级弹窗直接进行状态翻转
    deviceStateFlip(userOneRule) ///对设备的状态0和1进行翻转
    return
  } else if (publicDeviceTypeJudge(userOneRule.productCode, '02', '014','049')) {//代号 20231207-1
    ///调光
    if (userOneRule.openState === 1) {
      ////点击开关按钮图片时 如果是开着的状态，则直接关闭即可
      userOneRule.openState = 0 ////这个字段底层并不存在，靠服务端虚拟出来的，所以可能出现BUG
      userOneRule.openStateValue = 0
      return
    } else {
      ////正常处理  弹出二级页面
      vm.$showControlToast('config', oneRule)
    }
  } else if (
    publicDeviceTypeJudge(userOneRule.productCode, '06', '010', '015')
  ) {
    ///A电机   015 A0电机
    if (userOneRule.openState === 1) {
      ////点击开关按钮图片时 如果是开着的状态，则直接关闭即可
      userOneRule.openState = 2
      userOneRule.openStateValue = 0
      return
    } else if (userOneRule.openState === 4) {
      if (userOneRule.openStateValue > 0) {
        userOneRule.openState = 2
        userOneRule.openStateValue = 0
        return
      } else {
        ////正常处理  弹出二级页面
        vm.$showControlToast('config', oneRule)
      }
    } else {
      ////正常处理  弹出二级页面
      vm.$showControlToast('config', oneRule)
    }
  } else if (publicDeviceTypeJudge(userOneRule.productCode, '07', '013')) {
    // /门锁和安防
    if (userOneRule.passwordState === 1) {
      ///需要进行密码验证，不能直接翻转，直接调窗口处理
      vm.$showControlToast('config', oneRule)
    } else {
      ///不需要密码验证时，正常处理
      if (userOneRule.openState === 1) {
        ////点击开关按钮图片时 如果是开着的状态，则直接关闭即可
        userOneRule.openState = 0 ////
        // userOneRule.openStateValue = 0;
        return
      } else {
        ////正常处理  弹出二级页面
        vm.$showControlToast('config', oneRule)
      }
    }
  } else if (
    publicDeviceTypeJudge(userOneRule.productCode, '08', '016', '017', '018')
  ) {
    ///空调和 三合一环境面板 017A地暖
    if (userOneRule.openState === 1) {
      ////点击开关按钮图片时 如果是开着的状态，则直接关闭即可
      userOneRule.openState = 0
      return
    } else {
      ////正常处理  弹出二级页面
      vm.$showControlToast('config', oneRule)
    }
  } else if (publicDeviceTypeJudge(userOneRule.productCode, '023', '024')) {
    ///F路影视和A音乐
    ////不会到这里，因为没有开关按钮
  } else if (publicDeviceTypeJudge(userOneRule.productCode, '025')) {
    ///F双色控制
    if (userOneRule.openState != 0 || userOneRule.openStateValue != 0) {
      ////点击开关按钮图片时 如果是开着的状态，则直接关闭即可
      userOneRule.openState = 0
      userOneRule.openStateValue = 0
      return
    } else {
      ////正常处理  弹出二级页面
      vm.$showControlToast('config', oneRule)
    }
  } else if (publicDeviceTypeJudge(userOneRule.productCode, '026')) {
    ///F三色控制
    if (
      userOneRule.openState != 0 ||
      userOneRule.openStateValue != 0 ||
      userOneRule.openStateValue1 != 0 ||
      userOneRule.openStateValue2 != 0
    ) {
      ////点击开关按钮图片时 如果是开着的状态，则直接关闭即可
      userOneRule.openState = 0
      userOneRule.openStateValue = 0
      userOneRule.openStateValue1 = 0
      userOneRule.openStateValue2 = 0
      return
    } else {
      ////正常处理  弹出二级页面
      vm.$showControlToast('config', oneRule)
    }
  }
}

/////判断当前是否处于界面管理状态
const jieMianStateJudge = () => {
  // 界面管理状态判断
  if (store.state.configinfo.objectMoveState === true) {
    vm.$toast(
      '当前是界面管理状态，请先点击右上角退出！长按对象拖动，可进行排序哦~',
      3000
    )
    return false
  } else {
    return true
  }
}
////计算修改常用设备和常用场景时，添加收藏序号的值
const changefollowOrder = (bojectDataList, val) => {
  for (let i = 0; i < bojectDataList.length; i++) {
    if (bojectDataList[i].followOrder > val) {
      bojectDataList[i].followOrder--
    }
  }
}
////计算修改常用设备和常用场景时，取消收藏序号的值
const changefollowOrderInc = (bojectDataList, bojectData) => {
  let followOrderMax = 0
  for (let i = 0; i < bojectDataList.length; i++) {
    if (bojectDataList[i].followOrder > followOrderMax) {
      followOrderMax = bojectDataList[i].followOrder
    }
  }

  bojectData.followOrder = ++followOrderMax
  console.log(bojectData)
}

// 搜索 选择修改场景规则对象页面 处理指定页面的数据  不是通用的

const seraceData = (charData, objectData, objectDataBack) => {
  console.log(objectData);
  if (objectData && objectDataBack) {
    //数据是合法存在的
    objectData.sceneDeviceList = objectData.sceneDeviceList.concat(objectDataBack.sceneDeviceList);
    objectDataBack.sceneDeviceList.length = 0;
    if (charData.match(/^[ ]*$/)) {
      //说明为空 或多个空
    } else {
      let dataLength = objectData.sceneDeviceList.length;
      for (let i = 0; i < dataLength; i++) {
        if ((objectData.sceneDeviceList[i].remark + objectData.sceneDeviceList[i].regionName).indexOf(charData) == -1) {
          // && objectData.sceneDeviceList[i].checked == false
          // 说明没有这个字符
          objectDataBack.sceneDeviceList.push(objectData.sceneDeviceList[i]);
          objectData.sceneDeviceList.splice(i, 1);
          dataLength--;
          i--;
        }

      }

    }
    console.log(objectData.sceneDeviceList)
  }

}




export {
  computerNotShowEleCount,
  judgeActivePage,
  publicFadeInOut,
  objectClone,
  showStateText,
  smartSceneRuleImgChange,
  jieMianStateJudge,
  changefollowOrder,
  changefollowOrderInc,
  throttle,
  seraceData
  // stringClearStar0
}

// import { } from "common/tool"
